<template>
  <div
    class="option-card-wrapper"
    :class="
      `${selected ? 'selected' : ''} ${noAction ? 'no-action' : ''} ${disabled ? 'disabled' : ''}`
    "
    @click="() => actionHandler()">
    <div>
      <div class="option-title">
        <slot v-if="$slots['hero-icon-title']" name="hero-icon-title"></slot>
        <asset-v3 v-else dir="icons" :name="`${icon}.svg`" />
        {{ title }}
      </div>
      <div class="option-details">
        {{ details }}
      </div>
    </div>
    <div class="action-button">
      <slot v-if="$slots['hero-icon-status']" name="hero-icon-status" class="icon-wrapper"></slot>
      <div v-else-if="statusIcon" class="dynamic-icon-wrapper">
        <asset-v3 dir="icons" :name="`${statusIcon}.svg`" />
      </div>
      <div v-else class="icon-wrapper">
        <asset-v3 dir="icons" name="angle-right-circle-blue.svg" />
      </div>
    </div>
  </div>
</template>

<script>
import AssetV3 from '../../../components/common/AssetV3.vue';

export default {
  components: { AssetV3 },
  props: {
    title: {
      type: String,
      default: '',
    },
    details: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: 'money-circle-blue-small',
    },
    statusIcon: {
      type: String,
    },
    action: {
      type: Function,
      default: () => {},
    },
    selected: {
      type: Boolean,
      default: false,
    },
    noAction: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    actionHandler() {
      if (!this.noAction) {
        this.action();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.option-card-wrapper {
  padding: 19px;
  background: #FFFFFF;
  border: 1px solid #C4CDD5;
  box-sizing: border-box;
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.1), 0px 1px 2px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  position: relative;
  cursor: pointer;
  &.selected {
    background: #ECF6FA;
    border: 1px solid #72BEDA;
  }
  &.no-action {
    cursor: unset !important;
  }
  &.no-action:hover {
    border: 1px solid #C4CDD5 !important;
  }
  &.disabled {
    background: var(--gray-100);
    align-items: center;

    .option-title {
      color: var(--gray-500);

      svg, img {
        filter: invert(41%) sepia(32%) saturate(257%)
        hue-rotate(166deg) brightness(97%) contrast(81%);
      }
    }
  }
}
.option-card-wrapper:hover {
  padding: 19px;
  border: 1px solid #72BEDA;
  cursor: pointer;
}
.option-title {
  font-weight: bold;
  font-size: 16px;
  display: flex;
  line-height: 24px;
  color: #36A3CA;
}
.option-details {
  margin-left: 30px;
  margin-right: 55px;
  font-size: 14px;
  line-height: 20px;
  color: #637381;
  margin-top: 8px;
}
.action-button {
  position: absolute;
  right: 19px;
  display: flex;
  height: 100%;
  top: 0;
  align-items: center;
}
.action-button .icon-wrapper {
  padding: 5px;
  border-radius: 50%;
  background: #ECF6FA;
  display: flex;

  &.disabled {
    background-color: var(--gray-200);

    svg, img {
      filter: invert(41%) sepia(32%)
      saturate(257%) hue-rotate(166deg) brightness(97%) contrast(81%);
    }
  }

  svg, img {
    margin: 0;
  }
}
.selected .action-button .icon-wrapper  {
  padding: 5px;
  border-radius: 50%;
  background: #36A3CA;
  display: flex;
}
.action-button .dynamic-icon-wrapper {
  & img {
    height: 30px;
    width: 30px;
  }
}
@media (max-width: $sm) {
  .action-button{
    right: 12px;
  }
}
</style>
<style>
.selected .action-button .icon-wrapper img  {
  filter: brightness(0) invert(1);
}
.option-title > img, .option-title > svg {
  margin-right: 10px;
}
</style>
